export const codeLanguages = {
    javascript: {
        text: 'JavaScript',
        mode: 'javascript',
        mime: 'text/javascript'
    },
    json: {
        text: 'JSON',
        mode: 'javascript',
        mime: 'application/json'
    },
    html: {
        text: 'HTML',
        mode: 'xml',
        mime: 'text/html'
    },
    css: {
        text: 'CSS',
        mode: 'css',
        mime: 'text/css'
    },
    sql: {
        text: 'SQL',
        mode: 'sql',
        mime: 'text/x-sql'
    },
    python: {
        text: 'Python',
        mode: 'python',
        mime: 'text/x-python'
    },
    java: {
        text: 'Java',
        mode: 'clike',
        mime: 'text/x-java'
    },
    shell: {
        text: 'Shell',
        mode: 'shell',
        mime: 'text/x-sh'
    },
    powershell: {
        text: 'PowerShell',
        mode: 'powershell',
        mime: 'application/x-powershell'
    },
    bash: {
      text: 'Bash',
      mode: 'shell',
      mime: 'text/x-sh'
    },
    csharp: {
        text: 'C#',
        mode: 'clike',
        mime: 'text/x-csharp'
    },
    php: {
        text: 'PHP',
        mode: 'php',
        mime: 'text/x-php'
    },
    cpp: {
        text: 'C++',
        mode: 'clike',
        mime: 'text/x-c++src'
    },
    c: {
        text: 'C',
        mode: 'clike',
        mime: 'text/x-csrc'
    },
    go: {
        text: 'Go',
        mode: 'go',
        mime: 'text/x-go'
    },
    typescript: {
        text: 'TypeScript',
        mode: 'javascript',
        mime: 'text/typescript'
    },
    kotlin: {
        text: 'Kotlin',
        mode: 'clike',
        mime: 'text/x-kotlin'
    },
    ruby: {
        text: 'Ruby',
        mode: 'ruby',
        mime: 'text/x-ruby'
    },
    vbnet: {
        text: 'Visual Basic .NET',
        mode: 'vb',
        mime: 'text/x-vb'
    },
    swift: {
        text: 'Swift',
        mode: 'swift',
        mime: 'text/x-swift'
    },
    r: {
        text: 'R',
        mode: 'r',
        mime: 'text/x-rsrc'
    },
    rust: {
        text: 'Rust',
        mode: 'rust',
        mime: 'text/x-rustsrc'
    },
    objectivec: {
        text: 'Objective-C',
        mode: 'clike',
        mime: 'text/x-objectivec'
    },
    dart: {
        text: 'Dart',
        mode: 'dart',
        mime: 'application/dart'
    },
    scala: {
        text: 'Scala',
        mode: 'clike',
        mime: 'text/x-scala'
    },
    perl: {
        text: 'Perl',
        mode: 'perl',
        mime: 'text/x-perl'
    },
    haskell: {
        text: 'Haskell',
        mode: 'haskell',
        mime: 'text/x-haskell'
    },
    julia: {
        text: 'Julia',
        mode: 'julia',
        mime: 'text/x-julia'
    },
    yaml: {
        text: 'YAML',
        mode: 'yaml',
        mime: 'text/x-yaml'
    },
    xml: {
        text: 'XML',
        mode: 'xml',
        mime: 'application/xml'
    },
    markdown: {
        text: 'Markdown',
        mode: 'markdown',
        mime: 'text/x-markdown'
    },
    lua: {
        text: 'Lua',
        mode: 'lua',
        mime: 'text/x-lua'
    },
    dockerfile: {
        text: 'Dockerfile',
        mode: 'dockerfile',
        mime: 'text/x-dockerfile'
    },
    properties: {
        text: 'Properties',
        mode: 'properties',
        mime: 'text/x-properties'
    },
    ini: {
        text: 'INI',
        mode: 'properties',
        mime: 'text/x-ini'
    },
    diff: {
        text: 'Diff',
        mode: 'diff',
        mime: 'text/x-diff'
    },
    wasm: {
        text: 'WebAssembly',
        mode: 'wast',
        mime: 'text/webassembly'
    },
    jinja: {
      text: 'Jinja2',
      mode: 'jinja2',
      mime: 'text/jinja2'
    },
    http: {
      text: 'HTTP',
      mode: 'http',
      mime: 'message/http'
    },
    excel: {
      text: 'Spreadsheet',
      mode: 'spreadsheet',
      mime: 'text/x-spreadsheet'
    },
}